import {
  SharedModule,
  CustomDetailComponent,
  DataService,
  TypedBaseListComponent,
} from "@bb-vendure/admin-ui/core";
import { Component, OnInit } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import UserPointTableComponent from "./RecordTable/table.component";
import { Observable, switchMap } from "rxjs";
import {
  Customer,
} from "src/generated-gql/graphql";
@Component({
  selector: "user-point-records",
  templateUrl: "./records.component.html",
  standalone: true,
  imports: [SharedModule, UserPointTableComponent],
})
export default class UserPointRecordsComponent
  implements CustomDetailComponent, OnInit
{
  constructor(
    private dataService: DataService,
    private formBuilder: FormBuilder
  ) {}

  entity$: Observable<Customer>;
  detailForm = this.formBuilder.group({});
  customer$: Observable<Customer | null>;
  async ngOnInit() {
    this.customer$ = this.entity$.pipe(switchMap(async (entity) => entity));
  }
}
